const routeInfoProps = [ 'name', 'paramNames', 'params', 'queryParams' ];

export function isRouteInfo(routeInfo) {
  return Boolean(
    routeInfo && typeof routeInfo === 'object' && !Array.isArray(routeInfo)
    && routeInfoProps.every(p => p in routeInfo)
  );
}
